// extracted by mini-css-extract-plugin
export default {"container":"Inspiration_container__AhGw-","content":"Inspiration_content__qUlo9","image":"Inspiration_image__LFaHd","date":"Inspiration_date__-tRi8"};